const PERMISSION_KEY = 'notif_permission_requested'

export function useBrowserNotifications() {
  function isSupported() {
    return 'Notification' in window
  }

  function permission() {
    if (!isSupported()) return 'denied'
    return Notification.permission
  }

  async function requestPermission() {
    if (!isSupported() || Notification.permission === 'granted') return Notification.permission
    if (Notification.permission === 'denied') return 'denied'

    localStorage.setItem(PERMISSION_KEY, 'true')
    return await Notification.requestPermission()
  }

  function shouldAutoRequest() {
    return isSupported() && Notification.permission === 'default'
  }

  function show(title, options = {}) {
    if (!isSupported() || Notification.permission !== 'granted') return null

    const notif = new Notification(title, {
      icon: '/logo_small.png',
      badge: '/logo_small.png',
      tag: 'eskrag-notification',
      ...options,
    })

    return notif
  }

  return {
    isSupported,
    permission,
    requestPermission,
    shouldAutoRequest,
    show,
  }
}
